<script>
import moment from "moment";

export default {
  name: "TheMeetingSectionParamsMeeting",

  props: {
    meeting: Object,
  },

  computed: {
    meetingDate() {
      return this.meeting?.meeting_date ? moment(this.meeting.meeting_date).format('DD.MM.YYYY') : "Не указана"
    },

    meetingNumberSeatsAvailable() {
      return this.meeting?.number_seats_available || "Не указана"
    },

    meetingChairman() {
      return this.meeting?.chairman?.full_name || "Не указан"
    },

    meetingSecretary() {
      return this.meeting?.secretary?.full_name || "Не указан"
    },

    meetingChairmanStudent() {
      return this.meeting?.student_chairman_asset?.full_name || "Не указан"
    },


  },
}
</script>

<template>
  <div>
    <v-card-text>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>{{meetingDate}}</v-list-item-title>
          <v-list-item-subtitle>Дата заседания</v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-content>
          <v-list-item-title>{{meetingNumberSeatsAvailable}}</v-list-item-title>
          <v-list-item-subtitle>Доступно мест</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>{{meetingChairman}}</v-list-item-title>
          <v-list-item-subtitle>Председатель</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>{{meetingSecretary}}</v-list-item-title>
          <v-list-item-subtitle>Секретарь</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>{{meetingChairmanStudent}}</v-list-item-title>
          <v-list-item-subtitle>Председатель студ. актива</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-text>
      <span class="text-h6">Присутствовали</span>

      <div class="text-h6" v-if="meeting.listeners.length === 0">Не указаны</div>
      <v-chip-group v-else column>
        <v-chip
          v-for="listener in meeting.listeners"
          :key="listener.id"
          small
        >
          {{ listener.full_name }}
        </v-chip>
      </v-chip-group>
    </v-card-text>
  </div>
</template>

<style scoped>

</style>